import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  Divider,
  Icon,
  Typography,
  VStack,
} from '@vivaahealth/design-system';

import * as api from '../../../api';
import EmergencyContactCard from './EmergencyContact';
import EmergencyContactButton from './EmergencyContactButton';
import AddEmergencyContactModal from './EmergencyContactsModal/AddEmergencyContactModal';
import { ReactComponent as StaffShortageSvg } from '../../../assets/spotIllustrations/staff_shortage.svg';

const EmergencyContacts = (args: {
  value: api.Previsit.PatientEmergencyContact[];
  emergencyContactRelationships: api.Patient.EmergencyContactRelationship[];
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
}) => {
  const { t } = useTranslation('emergencyContacts');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const {
    value,
    saveFieldValue,
    updateFieldValue,
    emergencyContactRelationships,
  } = args;
  const startsAtOne = value[0] && value[0].rank === 1;
  const activeEmergencyContacts = value?.filter(
    (contact) => contact.status !== api.Previsit.ModificationStatus.Removed,
  );
  const hasActiveContacts = activeEmergencyContacts.length > 0;

  const contacts = activeEmergencyContacts.map((contact) => (
    <EmergencyContactCard
      key={contact.rank}
      emergencyContacts={value}
      rank={contact.rank}
      saveFieldValue={saveFieldValue}
      updateFieldValue={updateFieldValue}
      emergencyContactRelationships={emergencyContactRelationships}
      startsAtOne={startsAtOne}
    />
  ));

  return (
    <Box paddingTop={12}>
      <Card>
        {hasActiveContacts ? contacts : null}
        <Card.Body>
          <VStack
            alignItems="center"
            paddingY={hasActiveContacts ? 4 : 20}
            paddingX={hasActiveContacts ? 0 : 8}
          >
            {!hasActiveContacts ? (
              <>
                <StaffShortageSvg />
                <Box paddingBottom={8}>
                  <Typography variant="paragraph-large" color="secondary">
                    {t('noEmergencyContacts')}
                  </Typography>
                </Box>
              </>
            ) : (
              <Divider />
            )}
            <Box paddingTop={16} width={'100%'}>
              <EmergencyContactButton
                icon={<Icon.Plus />}
                message={t('addEmergencyContact')}
                onClickHandler={() => setIsOpen(true)}
              />
            </Box>
          </VStack>
        </Card.Body>
      </Card>
      {isOpen && (
        <AddEmergencyContactModal
          topLabel={t('addEmergencyContact')}
          emergencyContacts={value}
          onModalClose={() => setIsOpen(false)}
          isOpen={isOpen}
          saveFieldValue={saveFieldValue}
          updateFieldValue={updateFieldValue}
          emergencyContactRelationships={emergencyContactRelationships}
          startsAtOne={startsAtOne}
        />
      )}
    </Box>
  );
};

export default EmergencyContacts;
